import React, { useMemo, useState } from "react";

type Props = {
  codes: string[];
  onSelect: (code: string) => void;
};

const CellSearch: React.FC<Props> = ({ codes, onSelect }) => {
  const [q, setQ] = useState("");
  const list = useMemo(() => {
    const s = q.trim().toLowerCase();
    if (!s) return codes.slice(0, 50);
    return codes.filter((c) => c.toLowerCase().includes(s)).slice(0, 50);
  }, [codes, q]);

  const submit = () => {
    if (!q.trim()) return;
    const exact = codes.find((c) => c.toLowerCase() === q.trim().toLowerCase());
    const first = exact || list[0];
    if (first) onSelect(first);
    setQ("");
  };

  return (
    <div className="wm-field">
      <label className="wm-field-label" htmlFor="cell-q">
        Celulă
      </label>
      <input
        id="cell-q"
        className="wm-input"
        placeholder="ex. D04-R02-K01-P02-C03"
        value={q}
        onChange={(e) => setQ(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === "Enter") submit();
        }}
        list="wm-cell-datalist"
      />
      <button type="button" className="wm-btn" onClick={submit}>
        Jump
      </button>
      <datalist id="wm-cell-datalist">
        {list.map((c) => (
          <option key={c} value={c} />
        ))}
      </datalist>
    </div>
  );
};

export default CellSearch;
